import React from 'react';
import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import _Container from "ImpactHubProfileCard-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=Container";
import _IconGrid from "ImpactHubProfileCard-IconGrid.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=IconGrid";
import _CentralAvatar from "ImpactHubProfileCard-CentralAvatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=CentralAvatar";
import _IconTopLeft from "ImpactHubProfileCard-IconTopLeft.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=IconTopLeft";
import _IconTopRight from "ImpactHubProfileCard-IconTopRight.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=IconTopRight";
import _IconMiddleLeft from "ImpactHubProfileCard-IconMiddleLeft.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=IconMiddleLeft";
import _IconMiddleRight from "ImpactHubProfileCard-IconMiddleRight.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=IconMiddleRight";
import _IconBottomLeft from "ImpactHubProfileCard-IconBottomLeft.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=IconBottomLeft";
import _IconBottomMiddle from "ImpactHubProfileCard-IconBottomMiddle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=IconBottomMiddle";
import _IconBottomRight from "ImpactHubProfileCard-IconBottomRight.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=IconBottomRight";
import _ContentSection from "ImpactHubProfileCard-ContentSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=ContentSection";
import _Title from "ImpactHubProfileCard-Title.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=Title";
import _ButtonWrapper from "ImpactHubProfileCard-ButtonWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/impact_hub/ImpactHubProfileCard.tsx?styleId=ButtonWrapper";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const IconGrid = /*#__PURE__*/styled("div", null, {
  displayName: "IconGrid",
  styles: _IconGrid
});

const CentralAvatar = /*#__PURE__*/styled("div", null, {
  displayName: "CentralAvatar",
  styles: _CentralAvatar
});

const IconTopLeft = /*#__PURE__*/styled("div", null, {
  displayName: "IconTopLeft",
  styles: _IconTopLeft
});

const IconTopRight = /*#__PURE__*/styled("div", null, {
  displayName: "IconTopRight",
  styles: _IconTopRight
});

const IconMiddleLeft = /*#__PURE__*/styled("div", null, {
  displayName: "IconMiddleLeft",
  styles: _IconMiddleLeft
});

const IconMiddleRight = /*#__PURE__*/styled("div", null, {
  displayName: "IconMiddleRight",
  styles: _IconMiddleRight
});

const IconBottomLeft = /*#__PURE__*/styled("div", null, {
  displayName: "IconBottomLeft",
  styles: _IconBottomLeft
});

const IconBottomMiddle = /*#__PURE__*/styled("div", null, {
  displayName: "IconBottomMiddle",
  styles: _IconBottomMiddle
});

const IconBottomRight = /*#__PURE__*/styled("div", null, {
  displayName: "IconBottomRight",
  styles: _IconBottomRight
});

const ContentSection = /*#__PURE__*/styled("div", null, {
  displayName: "ContentSection",
  styles: _ContentSection
});

const Title = /*#__PURE__*/styled("p", null, {
  displayName: "Title",
  styles: _Title
});

const ButtonWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonWrapper",
  styles: _ButtonWrapper
});

interface Props {
  profilePictureUrl: string;
  className?: string;
}

export const ImpactHubProfileCard: React.FC<Props> = ({
  profilePictureUrl,
  className,
}) => {
  const impressionSource = 'impact_hub.profile.card';

  return (
    <Container className={className}>
      <IconGrid>
        {/* Central user profile picture */}
        <CentralAvatar>
          <img src={profilePictureUrl} alt="Profile" />
        </CentralAvatar>

        {/* Top-left animated images icon */}
        <IconTopLeft>
          <Icon name="animated_images" size={12} />
        </IconTopLeft>

        {/* Top-right comic bubble icon */}
        <IconTopRight>
          <Icon name="comic_bubble" size={12} />
        </IconTopRight>

        {/* Middle-left campaign icon */}
        <IconMiddleLeft>
          <Icon name="campaign" size={12} />
        </IconMiddleLeft>

        {/* Middle-right web stories icon */}
        <IconMiddleRight>
          <Icon name="web_stories" size={12} />
        </IconMiddleRight>

        {/* Bottom-left podcast icon */}
        <IconBottomLeft>
          <Icon name="mic" size={12} />
        </IconBottomLeft>

        {/* Bottom-middle lightbulb icon */}
        <IconBottomMiddle>
          <Icon name="lightbulb" size={12} />
        </IconBottomMiddle>

        {/* Bottom-right adaptive audio mic icon */}
        <IconBottomRight>
          <Icon name="adaptive_audio_mic" size={12} />
        </IconBottomRight>
      </IconGrid>

      <ContentSection>
        <Title>Transform your paper into different formats</Title>
        <ButtonWrapper>
          <ImpressionWatcher active={true} source={impressionSource}>
            <ButtonLink
              href={routes.impact_home_url()}
              size="xs"
              fullWidth={true}
              iconRight="arrow_forward"
            >
              Explore Impact Hub
            </ButtonLink>
          </ImpressionWatcher>
        </ButtonWrapper>
      </ContentSection>
    </Container>
  );
};
